import { render, staticRenderFns } from "./FormElementCheckbox.vue?vue&type=template&id=bd8b28ae"
import script from "./FormElementCheckbox.vue?vue&type=script&lang=js"
export * from "./FormElementCheckbox.vue?vue&type=script&lang=js"
import style0 from "./FormElementCheckbox.vue?vue&type=style&index=0&id=bd8b28ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports